export default __webpack_public_path__ + "static/media/placeholder.a52528ee.svg";